module.exports = __webpack_public_path__ + "static/media/ub1-removebg-preview.0fd68bf6.png";